// 配置路由文件

import { QuestionCircleOutlined, DownloadOutlined, UserOutlined, AppstoreOutlined, FileDoneOutlined, MoneyCollectOutlined, FundViewOutlined, PlusSquareOutlined, AccountBookOutlined, SettingOutlined, SmileOutlined, GiftOutlined, TagsOutlined, SolutionOutlined, MonitorOutlined, CarryOutOutlined, TeamOutlined, GlobalOutlined, BarChartOutlined } from '@ant-design/icons';

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    title: '用户管理',
    route: '/manager_client',
    icon: <TeamOutlined />,
    role: ['管理员'],
  },
  {
    title: '产品管理',
    route: '/goods',
    icon: <GiftOutlined />,
    role: ['管理员'],
  },
  {
    title: '订单管理',
    route: '/client_orders',
    icon: <AccountBookOutlined />,
    role: ['管理员'],
  },
  {
    title: '价格及设置',
    route: '/setting',
    icon: <SettingOutlined />,
    role: ['管理员'],
  },
]


